import { useMutation } from '@tanstack/react-query'

import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { extractApiErrorMessage, type DownloadFileResult, toDownloadFileResult } from './download-utils'

export interface GerarS3000S1210Request {
  file: File
  tpAmb?: string
  tbAmb?: string
}

export function useGerarS3000S1210() {
  const token = useAccessToken()
  const user = useCurrentUser()

  return useMutation({
    mutationFn: async ({ file, tpAmb, tbAmb }: GerarS3000S1210Request): Promise<DownloadFileResult> => {
      if (!file) {
        throw new Error('Arquivo é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const formData = new FormData()
      formData.append('file', file)
      if (tpAmb) formData.append('tpAmb', tpAmb)
      if (tbAmb) formData.append('tbAmb', tbAmb)

      try {
        const response = await api.post<Blob>('/previdenciario/gerar_s3000_s1210', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          responseType: 'blob'
        })

        if (!response.data) {
          throw new Error('Erro ao gerar S3000 de S1210')
        }

        return toDownloadFileResult(response, 's3000-s1210.zip')
      } catch (error) {
        throw new Error(await extractApiErrorMessage(error, 'Erro ao gerar S3000 de S1210'))
      }
    }
  })
}
